export const configs = new Object({
    statusUpdate:{
        transactionTypeForm:{
            "expense":{"id":"6b332fcd-59f7-28db-845c-06d7a8613f78"}
        },
        field:{
            "subtitle":{"id":"5b9dcbb4-697f-4115-ac86-79c3cb064617"}
        },
    }
})